import React from 'react';
import { IonModal, IonIcon } from '@ionic/react';
import IllyModalContent from './IllyModalContent.jsx';

export default function IllyModal(props) {
    const { showModal, setShowModal } = props;

    const onCloseHandler = () => setShowModal(false);

    React.useLayoutEffect(() => {
        setTimeout(() => setShowModal(true), 1200);
    }, [setShowModal]);

    return (
        <div className="illy-modal-content py-1">
            <IonModal cssClass="illy-modal-content" mode="md" isOpen={showModal} onDidDismiss={onCloseHandler}>
                <IllyModalContent closerHandler={onCloseHandler}></IllyModalContent>
            </IonModal>
        </div>
    );
}
